<template>
  <section id="business" class="rt-section business">
    <div class="rt-inner">
      <div class="rt-section-head">
        <span class="rt-eyebrow business__eyebrow">WHAT WE DO</span>
        <h2 class="rt-section-title">わたしたちの事業</h2>
      </div>

      <div class="business__feature">
        <div class="business__chips">
          <span class="business__chip" style="color:var(--brand-blue)">BLUE</span>
          <span class="business__chip" style="color:var(--brand-red)">RED</span>
          <span class="business__chip" style="color:var(--brand-pink)">PINK</span>
          <span class="business__chip" style="color:var(--brand-green)">GREEN</span>
        </div>
        <div class="business__rs-name">rights.services</div>
        <p class="business__rs-desc">
          次世代の印税管理システム。著作権・著作隣接権・その他の印税から、
          オンライン明細まで。4つのカラーがひとつのエコシステムに。
          システムのご提供は、今後この rights.services に一本化されます。
        </p>
        <a href="https://www.rights.services" target="_blank" rel="noopener noreferrer" aria-label="rights.services のサービスサイトへ（新しいタブで開きます）" class="rt-btn rt-btn--ink">
          サービスサイトへ <i class="fas fa-arrow-up-right-from-square" aria-hidden="true"></i>
        </a>
      </div>

      <div class="business__sub">
        <div class="business__icon">🎧</div>
        <h3 class="business__sub-title">印税計算業務の作業代行</h3>
        <p class="business__sub-desc">
          著作権再分配・原盤分配の計算業務を、経験豊富なチームが代行します。
          システム導入前でも、まるごとお任せいただけます。
        </p>
      </div>
    </div>
  </section>
</template>

<script>
export default { name: 'HomeBusiness' }
</script>

<style scoped>
.business {
  background: var(--base);
}

.business__eyebrow {
  color: var(--brand-pink);
  background: var(--pink-bg);
}

.business__feature {
  background: linear-gradient(135deg, var(--blue-bg), var(--pink-bg) 55%, var(--green-bg));
  border: 1px solid var(--line);
  border-radius: var(--radius-lg);
  padding: 30px;
  text-align: left;
  margin-bottom: 16px;
}

.business__chips {
  display: flex;
  gap: 6px;
  margin-bottom: 14px;
}

.business__chip {
  font-family: var(--font-lat);
  font-size: 12px;
  font-weight: 700;
  background: #fff;
  padding: 3px 11px;
  border-radius: var(--radius-pill);
}

.business__rs-name {
  font-family: var(--font-lat);
  font-size: 26px;
  font-weight: 700;
  color: var(--ink);
}

.business__rs-desc {
  font-size: 14px;
  line-height: 1.9;
  color: var(--ink-soft);
  margin: 10px 0 18px;
}

.business__sub {
  background: var(--surface);
  border: 1px solid var(--line);
  border-radius: var(--radius-lg);
  padding: 30px;
  text-align: left;
}

.business__icon {
  font-size: 28px;
}

.business__sub-title {
  font-size: 18px;
  font-weight: 700;
  color: var(--ink);
  margin-top: 6px;
}

.business__sub-desc {
  font-size: 14px;
  line-height: 1.9;
  color: var(--ink-soft);
  margin-top: 8px;
}
</style>
